import { render, staticRenderFns } from "./PaymentProductsSelectbox.vue?vue&type=template&id=2a7f1ff4"
import script from "./PaymentProductsSelectbox.vue?vue&type=script&lang=js"
export * from "./PaymentProductsSelectbox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports